"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPrismaClientValidationError = exports.isPrismaClientUnknownRequestError = exports.isPrismaClientKnownRequestError = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
function isPrismaClientKnownRequestError(err) {
    return findConstructorName(err.__proto__, 'PrismaClientKnownRequestError');
}
exports.isPrismaClientKnownRequestError = isPrismaClientKnownRequestError;
function isPrismaClientUnknownRequestError(err) {
    return findConstructorName(err.__proto__, 'PrismaClientUnknownRequestError');
}
exports.isPrismaClientUnknownRequestError = isPrismaClientUnknownRequestError;
function isPrismaClientValidationError(err) {
    return findConstructorName(err.__proto__, 'PrismaClientValidationError');
}
exports.isPrismaClientValidationError = isPrismaClientValidationError;
function findConstructorName(proto, name) {
    if (!proto) {
        return false;
    }
    return proto.constructor.name === name || findConstructorName(proto.__proto__, name);
}
//# sourceMappingURL=error.js.map